import moment from "moment";
import { MESSAGE } from "@/model/Message";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends"
import { Uketsuke } from "@/model/Uketsuke";
import { CALENDAR_YEAR } from "@/model/CALENDAR_YEAR";
import { MAXSOUKOUKM, MAXSOUKOUMILE } from "@/model/MAXSOUKOUKM";

export function formatDate(
  strDate: string,
  outputFormat: string,
  inputFormat: string = "YYYYMMDD"
): string {
  return moment(strDate, inputFormat).format(outputFormat);
}

export function getDate(strDate: string,) {
  return moment(strDate, "YYYYMMDD").toDate();
}

export function getFullDate(strDate: string, format: string): string {
  const date = moment(strDate, format);
  const year = date.format("YYYY");
  let dateOutput = "";

  if (format.indexOf("Y") > -1) {
    let era = findEra(date);
    if(era.Char) {
      let jaYear = Number(year) - era.Diff;
      dateOutput += era.YearNm + jaYear + "年";
    }
  }
  if (format.indexOf("M") > -1) {
    dateOutput += date.format("M月");
  }
  if (format.indexOf("D") > -1) {
    dateOutput += date.format("D日");
  }

  return dateOutput;
}

export function findEra(date: any) {
  if(date instanceof Date) {
    date = moment(date);
  }
  for (let i = CALENDAR_YEAR.length - 1; i > 0; i--) {
    if (date.isSameOrAfter(moment(CALENDAR_YEAR[i].Start, "YYYYMMDD"))) {
      return CALENDAR_YEAR[i];
    }
  }
  return CALENDAR_YEAR[0];
}

export function getJapanDate(strDate: string, format: string): string {
  if (strDate == "") {
    return "";
  }
  const date = moment(strDate, format);
  const year = date.format("YYYY");
  let era = findEra(date);
  if(era.Char) {
    let jaYear = Number(year) - era.Diff;
    let dateOutput = era.Char + padNumber(jaYear.toString(), 2);
    if (format.length > 4) {
      let outputformat = format
        .replace("YYYY", "")
        .replace("MM", "/MM")
        .replace("DD", "/DD");
      dateOutput += date.format(outputformat);
    }
    return dateOutput;
  }
  return "";
}

export function getNow(format: string): string {
  return moment().format(format);
}

export function dateToFormat(date: Date, format: string): string {
  return moment(date).format(format);
}

export function setSelect(element: HTMLInputElement) {
  element.select();
}

export function focusNext(index: number, id?: string) {
  let nextEl: any;
  if (id) {
    nextEl = document.getElementById(id);
  } else if (index != null) {
    nextEl = document.querySelector(`[index='${index + 1}'`);
    if (!nextEl) {
      nextEl = document.querySelector(`[index='${index + 2}'`);
    }
  }
  if (nextEl) {
    setTimeout(() => {
      nextEl.focus();
    }, 200);
  }
}

export function padNumber(input: string, n: number): string {
  let s = input;
  while (s.length < n) {
    s = "0" + s;
  }
  return s;
}

export function getNumberThousandSeparate(input: number): string {
  return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function getUTF8Length(str: string, maxbyte: number) {
  if (str === "" || str == null) {
    return { count: 0, strCount: 0 };
  }
  let ch = null;
  let count = 0;
  let countTxt = 0;
  for (let i = 0; i < str.length; i++) {
    ch = str.charCodeAt(i);

    if (
      (ch >= 0x0 && ch < 0x81) ||
      ch === 0xf8f0 ||
      (ch >= 0xff61 && ch < 0xffa0) ||
      (ch >= 0xf8f1 && ch < 0xf8f4)
    ) {
      count += 1;
    } else {
      count += 2;
    }

    if (count <= maxbyte) {
      countTxt++;
    }
  }

  return { count: count, strCount: countTxt };
}

export function removeLeadingZero(str: string) {
  return str.replace(/^0+/g, "");
}

export function toASCII(chars: string) {
  var ascii = "";
  chars = chars.replace("。", ".");
  for (var i = 0, l = chars.length; i < l; i++) {
    var c = chars[i].charCodeAt(0);
    if (c >= 0xff00 && c <= 0xffef) {
      c = 0xff & (c + 0x20);
    }
    ascii += String.fromCharCode(c);
  }

  return ascii;
}

export function getDurationMonth(startDate: string, endDate: string) {
  if (startDate && endDate) {
    const format = "YYYYMMDD";
    let start = moment(startDate, format);
    let end = moment(endDate, format);
    let duration = moment.duration(start.diff(end));
    return Math.ceil(duration.asMonths());
  }
  return 0;
}

export function getWSData(frame: any) {
  return JSON.parse(frame.body);
}

export function removeNonEng(str: string) {
  return str.replace(/[^A-Za-z\d]/g, "");
}

export function getHttpErrorMessage(error: {
  status: number;
  rsltComment: string;
}) {
  if (error.status == 204) {
    return MESSAGE.NoData;
  } else if (error.status < 500 && error.rsltComment) {
    return error.rsltComment;
  } else {
    return MESSAGE.SystemError;
  }
}

export function deepCopy(obj: any){
  return JSON.parse(JSON.stringify(obj));
}

export function calSoukouAvg(soukouKm: number, sknUketsukeExtends: SknUketsukeExtends, uketsuke: Uketsuke) {
  let avg = 0;
  if (soukouKm > 0 &&
    sknUketsukeExtends &&
    uketsuke.workPlansYmd &&
    sknUketsukeExtends.zenkaiSoukouYmd
  ) {
    let month = getDurationMonth(
      uketsuke.workPlansYmd,
      sknUketsukeExtends.zenkaiSoukouYmd
    );
    if (month > 0) {
      let lastSoukouKm = 0;
      if (sknUketsukeExtends.zenkaiSoukouKm) {
        lastSoukouKm = Number(sknUketsukeExtends.zenkaiSoukouKm);
      }
      avg = Math.ceil((soukouKm - lastSoukouKm) / month);
    }
  }
  return avg;
}

export function calSoukouMileAvg(soukouMile: number, sknUketsukeExtends: SknUketsukeExtends, uketsuke: Uketsuke) {
  let avg = 0;
  if (soukouMile > 0 &&
    sknUketsukeExtends &&
    uketsuke.workPlansYmd &&
    sknUketsukeExtends.zenkaiSoukouYmd
  ) {
    let month = getDurationMonth(
      uketsuke.workPlansYmd,
      sknUketsukeExtends.zenkaiSoukouYmd
    );
    if (month > 0) {
      let lastSoukouMile = 0;
      if (sknUketsukeExtends.zenkaiSoukouMile) {
        lastSoukouMile = Number(sknUketsukeExtends.zenkaiSoukouMile);
      }
      avg = Math.ceil((soukouMile - lastSoukouMile) / month);
    }
  }
  return avg;
}

export function checkLimitSoukou(soukou: number, unitKbn: any) {
  if (unitKbn === 2) {
    return soukou > MAXSOUKOUMILE;
  } else {
    return soukou > MAXSOUKOUKM;
  }
}
export function msgExceedSoukou(unitKbn: any) {
  const max = unitKbn === 2 ? MAXSOUKOUMILE : MAXSOUKOUKM;
  const max_str = getNumberThousandSeparate(max);
  const unit = unitKbn === 2 ? "mile" : "km";
  return `走行距離は、${max_str}${unit}以内で入力してください。`
}
